<template>
  <div class="admissions-table">
    <el-table
      :data="dataInfo"
      border
      stripe
      max-height="800"
      :header-cell-style="{
        background: '#4c84ff',
        color: '#fff',
        height: '60px',
        textAlign: 'center'
      }"
    >
      <el-table-column
        prop="shop_name"
        label="店铺"
        align="center"
        fixed
        width="150"
      />
      <el-table-column
        prop="leads_num"
        label="Leads数"
        align="center"
      />
      <el-table-column
        prop="leads_transfer_num"
        label="转校Leads数"
        align="center"
      />
      <el-table-column
        prop="appointment_visit_num"
        label="约访上门量"
        align="center"
      />
      <el-table-column
        prop="visit_num"
        label="上门量"
        align="center"
      />
      <el-table-column
        prop="through_review_num"
        label="新签人数"
        align="center"
      />
      <el-table-column
        prop="through_review_price"
        label="新签总额"
        align="center"
      />
      <el-table-column
        prop="through_review_real_price"
        label="新签实收"
        align="center"
      />
      <el-table-column label="新签率" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.leads_num == 0
              ? "0%"
              : `${(
                (scope.row.through_review_num / scope.row.leads_num) *
                100
              ).toFixed(2)}%`
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="新签平均单笔金额" align="center">
        <template slot-scope="scope">
          <span>{{
            (scope.row.through_review_num == 0
              ? 0
              : scope.row.through_review_price / scope.row.through_review_num
            ).toFixed(2)
          }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'AdmissionsTable',
  props: {
    dataInfo: Array
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.admissions-table {
}
</style>
